import { render, staticRenderFns } from "./OvasTeachers.html?vue&type=template&id=5b9104cd&scoped=true&"
import script from "./OvasTeachers.vue?vue&type=script&lang=js&"
export * from "./OvasTeachers.vue?vue&type=script&lang=js&"
import style0 from "./OvasTeachers.scss?vue&type=style&index=0&id=5b9104cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9104cd",
  null
  
)

export default component.exports